import HeatmapItem, {HEATMAP_TYPE} from '../components/items/Heatmap/HeatmapItem';
import {
	clearNeedsRecalculation,
	getCachedHeatmapData,
	getGroupCache,
	getProjectHeatmapData,
	getStepCache,
} from './HeatmapLogic';
import {hasFeatureFlag} from '../../../forecast-app/shared/util/FeatureUtil';
import DataManager from '../DataManager';

const constructProjectGroupHeatmapItem = (pageComponent, group, stepData, heatmapData) => {
	return new HeatmapItem(pageComponent, HEATMAP_TYPE.PROJECT_ENTITY, {
		y: group.screenY,
		x: stepData.position,
		width: stepData.width,
		groupHeight: group.totalHeight,
		...heatmapData,
	});
};

export const composeProjectGroupHeatmap = (pageComponent, group, stepDataArray, timelineStartDate, timelineMinorStep) => {
	group.calculateHeatmapCache(group, stepDataArray, timelineMinorStep);

	const heatmapItems = [];
	for (const stepData of stepDataArray) {
		let {startDate, endDate} = stepData;
		const heatmapData = getCachedHeatmapData(pageComponent, group, timelineMinorStep, startDate, endDate);
		heatmapItems.push(constructProjectGroupHeatmapItem(pageComponent, group, stepData, heatmapData));
	}

	return heatmapItems;
};

export const calculateProjectGroupHeatmapCache = (pageComponent, group, stepDataArray, timelineMinorStep) => {
	const overallStartDate = stepDataArray[0].startDate;
	const overallEndDate = stepDataArray[stepDataArray.length - 1].endDate;

	let visibleItemsData;
	const fetchVisibleItemsData = () => {
		if (!visibleItemsData) {
			visibleItemsData = DataManager.getVisibleItemsData(pageComponent, group, overallStartDate, overallEndDate);
		}

		return visibleItemsData;
	};

	// Update cache for step
	const groupCache = getGroupCache(pageComponent, group.id);
	const stepCache = getStepCache(groupCache, timelineMinorStep);
	for (const stepData of stepDataArray) {
		let {startDate, endDate} = stepData;
		getProjectHeatmapData(
			pageComponent,
			group,
			groupCache,
			stepCache,
			startDate,
			endDate,
			timelineMinorStep,
			fetchVisibleItemsData
		);
	}

	if (!hasFeatureFlag('scheduling_recalculation_tree')) {
		clearNeedsRecalculation(groupCache, timelineMinorStep);
	}
};
